


























































































































































































































import centrosModule from "@/store/modules/centros-module";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class ProgresImport extends Vue {
  progreso: number = 0;
  actualizando: boolean = false;
  forzandoProceso: boolean = false;
  intervalo: number | null = null;
  ultimoProgreso: number = 0;
  tiempoSinAvance: number = 0;
  mostrarBotonForzar: boolean = false;
  dialogAdvertencia: boolean = false;

  progreso_data = {
    rutas_calculadas: 0,
    total_posibles: 0,
  };

  mounted() {
    this.iniciarProgreso();
  }

  beforeDestroy() {
    this.limpiarIntervalo();
  }

  iniciarProgreso() {
    this.obtenerProgreso();
    this.intervalo = setInterval(() => {
      this.obtenerProgreso();
    }, 2000); // Reducido a 2 segundos para mejor UX
  }

  limpiarIntervalo() {
    if (this.intervalo) {
      clearInterval(this.intervalo);
      this.intervalo = null;
    }
  }

  async obtenerProgreso() {
    try {
      const res = await centrosModule.ProgresoCalculoRutas();
      this.progreso_data = {
        rutas_calculadas: res.rutas_calculadas,
        total_posibles: res.total_posibles,
      };

      const nuevoProgreso =
        this.progreso_data.total_posibles > 0
          ? (this.progreso_data.rutas_calculadas /
              this.progreso_data.total_posibles) *
            100
          : 0;

      // Verificar si hay avance en el progreso
      if (nuevoProgreso === this.ultimoProgreso && this.progreso < 100) {
        this.tiempoSinAvance += 2; // Incrementar tiempo sin avance (2 segundos por intervalo)
        if (this.tiempoSinAvance >= 30) {
          // 2 minutos = 120 segundos
          this.mostrarBotonForzar = true;
        }
      } else {
        this.tiempoSinAvance = 0; // Resetear tiempo sin avance
        this.mostrarBotonForzar = false;
        this.ultimoProgreso = nuevoProgreso;
      }

      this.progreso = nuevoProgreso;

      if (this.progreso >= 100) {
        this.limpiarIntervalo();
        this.$emit("proceso-completado");
      }
    } catch (error) {
      console.error("Error al obtener el progreso:", error);
      this.$emit("error-progreso", error);
    }
  }

  async actualizarProgreso() {
    this.actualizando = true;
    await this.obtenerProgreso();
    this.actualizando = false;
  }

  async IniciarProcesoCalculoRutas() {
    this.forzandoProceso = true;
    try {
      await centrosModule.IniciarProcesoCalculoRutas();
      this.mostrarBotonForzar = false;
      this.tiempoSinAvance = 0;
      this.ultimoProgreso = 0;
      // Reiniciar el monitoreo
      this.iniciarProgreso();
    } catch (error) {
      console.error("Error al forzar el proceso:", error);
      this.$emit("error-forzar-proceso", error);
    } finally {
      this.forzandoProceso = false;
      this.dialogAdvertencia = false;
    }
  }

  confirmarForzarProceso() {
    this.dialogAdvertencia = true;
  }

  cancelarForzarProceso() {
    this.dialogAdvertencia = false;
  }
}
